import { Alert, Platform } from 'react-native';

/** Reliable alerts on web (RN Alert is often a no-op in the browser). */
export function showAlert(title: string, message?: string): void {
  if (Platform.OS === 'web') {
    window.alert(message ? `${title}\n\n${message}` : title);
    return;
  }
  Alert.alert(title, message);
}
